module.exports = __webpack_public_path__ + "img/closebtn-icon-active.c93d3457.svg";